<template>
  <div class="mo-navbar-card">
    <template v-for="(menu,index) in menus">
      <template v-if="menu.showNavCardDash">
        <el-row :key="index" class="mo-navbar-card-item">
          <el-row>
            <el-col :span="24">
              <template v-if="menu.routerName!==null">
                <div class="mo-navbar-card-item-header">
                  <i :class="(menu.iconFill)?'fill':''" class="material-symbols-rounded">{{ menu.icon }}</i>
                  <h2 style="cursor: pointer;" @click="$router.push({ name: menu.routerName })">{{ menu.title }}</h2>
                </div>
              </template>
              <template v-else>
                <div class="mo-navbar-card-item-header">
                  <i :class="(menu.iconFill)?'fill':''" class="material-symbols-rounded">{{ menu.icon }}</i>
                  <h2>{{ menu.title }}</h2>
                </div>
              </template>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <template v-for="(childMenu, childIndex) in menu.childs">
              <template v-if="childMenu.showNavCardDash">
                <el-col
                  v-show="(childMenu.idMenu !== 502 && !isUnimed) || (isUnimed)"
                  :key="childIndex"
                  :lg="6"
                  :md="8"
                  :sm="12"
                  :xl="4"
                  :xs="24"
                >
                  <div class="mo-navbar-card-item-blocks">
                    <div class="mo-header" @click="goTo(childMenu)">
                      <div>
                        <h2>{{ childMenu.name }}</h2>
                        <p>{{childMenu.nameApplication}}</p>
                      </div>
                      <div v-if="childMenu.externalLink">
                        <i class="material-symbols-rounded icon_externalLink">open_in_new</i>
                      </div>
                      <div v-else-if="childMenu.isApplication" style="max-height: 40px; max-width: 40px;">
                        <div v-if="childMenu.image" class="mo-header-icon" style="max-height: 100%; max-width: 100%;">
                          <img :src="childMenu.image" alt="icon" style="max-height: 100%; max-width: 100%;"/>
                        </div>
                        <div v-else class="mo-header-icon" style="max-height: 100%; max-width: 100%;">
                          <i :class="(childMenu.iconFill)?'fill':''" class="material-symbols-rounded" style="font-size: 40px;">{{ childMenu.icon }}</i>
                        </div>
                      </div>
                    </div>
                    <div class="mo-body" @click="goTo(childMenu)">
                      <p>{{ childMenu.description }}</p>
                    </div>
                    <el-row v-if="childMenu.parent">
                      <el-col :span="24">
                        <a
                          class="mo-navbar-card-item-footer"
                          @click="$router.push({ name: childMenu.parent.routerName })"
                        >
                          <span>{{ childMenu.parent.title }}</span>
                        </a>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </template>
            </template>
          </el-row>
        </el-row>
      </template>
    </template>
  </div>
</template>

<script>
import { isUnimed } from '@/utils/utils'

export default {
  name: 'navbar-card',
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isUnimed () {
      return isUnimed()
    },
    idConfigClienteApp () {
      return this.$route.params.idConfigClienteApp || ''
    }
  },
  methods: {
    goTo (childMenu) {
      const to = {}

      if (childMenu.routerPath) {
        to.path = childMenu.routerPath.replace(':idConfigClienteApp', this.idConfigClienteApp)
      } else {
        to.name = childMenu.routerName
      }
      this.$router.push(to)
    }
  }
}
</script>

<style lang="scss" scoped>
.mo-navbar-card {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-family: "Open Sans", sans-serif;

  .mo-navbar-card-item {
    width: 100%;
    padding: 10px;

    .mo-navbar-card-item-header {
      display: flex;
      align-items: center;

      h2 {
        margin-left: 10px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
      }

      i {
        font-size: 24px;

        &.fill {
          color: #5D8CBA;
        }
      }
    }

    .mo-navbar-card-item-blocks {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      background: #F4F9FF padding-box;
      border-radius: 8px;
      min-height: 115px;
      //min-width:270px;
      margin-top: 12px;
      padding-inline: 20px;
      padding-block: 20px;

      &:hover {
        background: #E5F1FD 0% 0% no-repeat padding-box;
        cursor: pointer;
      }

      .mo-header {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        h2 {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }

        i {
          font-size: 16px;
          color: #5D8CBA;
        }
      }

      .mo-body {
        width: 100%;
        min-height: 90px;
        display: block;

        p {
          text-align: left;
          font: normal normal normal 12px/17px Open Sans;
          letter-spacing: 0px;
          color: #5D8CBA;
        }
      }
    }

    .mo-navbar-card-item-footer {
      text-align: left;
      text-decoration: underline;
      font: normal normal 600 10px/14px Open Sans;
      letter-spacing: 0px;
      color: #0075EA;
      text-transform: uppercase;
    }
  }
}

/* Element UI */
.el-col {

}

.el-row {
  margin-bottom: 0px;

  &:last-child {
    margin-bottom: 0;
  }
}

/* Material Icons */
.material-symbols-rounded {
  font-variation-settings: 'FILL' 0,
  'wght' 400,
  'GRAD' 200,
  'opsz' 48;

  color: #0075EA;
}

.fill {
  font-variation-settings: 'FILL' 1
}
</style>
